import { Typography } from "@mui/material";
import { Container } from "@mui/system";
import React from "react";
import styles from "./Header.module.css";
import stanbic_logo from "assets/images/stanbic_logo.svg";
import search_icon from "assets/images/search-icon.svg";
import user_icon from "assets/images/user-icon.svg";
import { Link } from "react-router-dom";

function Header() {
  return (
    <header className={styles.header}>
      <Container maxWidth="lg">
        <div className={styles.header_content}>
          <div className={styles.header_content_left}>
            <div className={styles.logo}>
              <img src={stanbic_logo} alt="stanbic ibtc logo" />
            </div>
            {/* <div className={styles.links_search}>
              <div className={styles.links}>
                <a href="/">Products and services</a>
                <a href="/">Ways to bank</a>
                <a href="/">News</a>
                <a href="/">FAQS</a>
                <a href="/">Product</a>
              </div>
              <div className={styles.search}>
                <img src={search_icon} alt="search icon" />
              </div>
            </div> */}
          </div>

          {/* <div className={styles.sign_in}>
            <a href="https://app.mooningassets.com/signup">
              <Typography>Sign into your accounts</Typography>
              <img src={user_icon} alt="user icon" />
            </a>
          </div> */}
          <a href="#faqs">FAQs</a>
       
        </div>
      </Container>
    </header>
  );
}

export default Header;
